module.exports = __webpack_public_path__ + "img/AI.91d87623.svg";